/* eslint-disable no-console */
import { useEffect, useState } from 'react';

import { SESSION_STORAGE } from '../../../constants/session-storage.constants';
import { useAuth } from '../../../hooks/useAuth';
import { saveProfile } from '../../../operations/users';
import {
  SectionTitle,
  SectionDescription,
  FormGroup,
  FormLabel,
  FormInput,
  SaveButton,
  AlertBox,
} from './styles';

export type ProfileValues = {
  name: string;
  email: string;
};

export const Profile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user, setUser } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (user) {
      setName(user.name !== user.customer_name ? user.name : '');
      setEmail(user.email || '');
    }
  }, [user]);

  async function handleSaveProfile(e: React.FormEvent) {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { appUser } = await saveProfile({ name, email });
      const { name: newName, email: newEmail, pendent_email } = appUser;
      setUser((userInState) => ({
        ...userInState,
        name: newName,
        email: newEmail,
        pendent_email,
      }));
      sessionStorage.removeItem(SESSION_STORAGE.SHOW_INCOMPLETE_REGISTER_WARNING);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <SectionTitle>Perfil</SectionTitle>
      <SectionDescription>
        Atualize suas informações pessoais.
      </SectionDescription>

      {!!user?.pendent_email && (
        <AlertBox>
          Foi enviado um e-mail de confirmação para <strong>{user.pendent_email}</strong>
        </AlertBox>
      )}

      <form onSubmit={handleSaveProfile}>
        <FormGroup>
          <FormLabel htmlFor="name">Nome completo</FormLabel>
          <FormInput
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Insira o seu nome completo"
          />
        </FormGroup>

        <FormGroup>
          <FormLabel htmlFor="email">E-mail</FormLabel>
          <FormInput
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Insira o seu e-mail"
          />
        </FormGroup>

        <SaveButton type="submit" disabled={isLoading}>
          {isLoading ? 'Salvando...' : 'Salvar'}
        </SaveButton>
      </form>
    </>
  );
};
